const parseFormattedEuro = (value) => {
  if (!value) return null;
  const normalized = String(value)
    .replace(/[^\d,.-]/g, "")
    .replace(/\.(?=\d{3}(?:\D|$))/g, "")
    .replace(",", ".");
  const amount = Number(normalized);
  return Number.isFinite(amount) ? amount : null;
};

const yearlyFromMonthlyPrice = (formatted) => {
  const monthly = parseFormattedEuro(formatted);
  if (monthly == null) return "";
  return (
    (monthly * 12).toLocaleString("fr-FR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + " €"
  );
};

export const catalogFromStatusData = (data) => ({
  attachments: (data && data.attachments) || [],
});

const sources = {
  plans: ({ insurancePlans, planPrices, project }) => {
    const selectedIds =
      (project && project.fields && project.fields.selectedToCompare) || [];
    const all = insurancePlans || [];
    if (!selectedIds.length) return [];
    const ordered = selectedIds
      .map((id) => all.find((plan) => plan.id === id))
      .filter(Boolean);
    return ordered.map((plan) => {
      const price = (planPrices && planPrices[plan.id]) || "";
      const yearly = yearlyFromMonthlyPrice(price);
      return {
        ...plan,
        ...(price ? { price } : {}),
        ...(yearly ? { yearly } : {}),
      };
    });
  },
};

export const getCollectionItems = (collectionName, ctx) => {
  const source = sources[collectionName];
  return source ? source(ctx) : [];
};
